import { render, staticRenderFns } from "./AdditionalInfoPanel.vue?vue&type=template&id=7e813c84&scoped=true"
import script from "./AdditionalInfoPanel.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e813c84",
  null
  
)

export default component.exports